import React, { useEffect, useRef, useState } from "react";
import { NavigationFunction as RootNavigation, Pages } from "../../../Navigation/Routers/root"
import { useNavigate } from 'react-router';
import { useTranslation } from "react-i18next";
import { InputField, PageHeader, SelectField, ArchivedReportCard, Button } from "../../../Components";
import { FieldTypes, FieldStyles, ButtonTypes } from "../../../Definitions";
import { colors, frames, glyphs, mediaQueriesNumbers, useMediaQuery } from "../../../Styles";

import { TestData as ArchivedReportData } from "../../../Assets/TestData/reports";

// Extract feedCurveNo as feedCurveId from FeedCurvesData
const reportIds = ArchivedReportData.map(report => report.reportNo);

export default function Archive() {
  const {t} = useTranslation()

  const navigator = useNavigate()
  const [showReport, setShowReport] = useState<number|undefined>(undefined)

  const [isFiltered, setIsFiltered] = useState<number>(0)
  const mobileXs = useMediaQuery(`(max-width: 500px)`);
  const [showfilterSearchList, setShowfilterSearchList] = useState<boolean>(false)
  const pageHeaderResponsive = useMediaQuery(`(min-width: 500px) and (max-width: ${mediaQueriesNumbers.pageHeaderResponsive2elementsMax}px)`);
  const filterSearchListRef = useRef<HTMLDivElement>(null);
  
  const onReportSelect = (id: number) => {
    console.log("Report selected with ID:", id);
    setShowReport(id);
    
    const selectedArchivedReportData = ArchivedReportData.find(report => report.reportNo === id);
    if (selectedArchivedReportData) {
      RootNavigation(navigator, Pages.reports, Pages.report, true, { selected: selectedArchivedReportData?.reportNo });
    }
  };

  useEffect(() => {
    console.log("useEffect triggered with showReport:", showReport);
    if (showReport !== undefined) {
      const selectedArchivedReportData = ArchivedReportData.find(report => report.reportNo === showReport);
      if (selectedArchivedReportData) {
        console.log("Selected report data:", selectedArchivedReportData);
      } else {
        console.log("No report data found for reportNo:", showReport);
      }
    }
  }, [showReport]);

  const filterByOptions = [   
    { label: t("reports.filterByNumber"), id: 0 },
    { label: t("reports.filterByName"), id: 1 },
  ]

    // Handle selection change
    const handleFilterChange = (selectedOption: { id: number }) => {
      setIsFiltered(selectedOption.id);
    };

  // Sorted and filtered reports based on the selected filter
  const sortedReports = [...ArchivedReportData].sort((a, b) => {
    if (isFiltered === 0) { // Sort by Report Number
      return a.reportNo - b.reportNo;
    } else if (isFiltered === 1) { // Sort by Report Name
      return a.name.localeCompare(b.name);
    }
    return 0;
  }).map(report => ({
    id: report.reportNo,
    label: report.name,
  }));

  // #region | Filter/search list
  const filterSearchList = (
    <div style={{  display: "flex", flexDirection: mobileXs ? "column" : "row", gap: "10px", zIndex: "10", backgroundColor: mobileXs ? colors.greyDarkPrimary : "", padding: mobileXs ? "20px" : "0px", borderRadius: mobileXs ? "10px" : "0px", boxShadow: mobileXs ? "0px 0px 5px 2px"+colors.blackPrimary+"4d" : "none"}}>
      <SelectField onChange={() => handleFilterChange} overrides={{fieldStyle: mobileXs ? FieldStyles.greyDarkSecondary : FieldStyles.greyDarkPrimary, fieldType: pageHeaderResponsive? FieldTypes.shortInputField : FieldTypes.primaryInputField, textStart: true}} placeholder={t("filterBy")+"..."} isClearable={true} options={filterByOptions} />
      <InputField fieldStyle={mobileXs ? FieldStyles.greyDarkSecondary : FieldStyles.greyDarkPrimary} placeholder={t("search")+"..."} textStart={true} fieldType={ pageHeaderResponsive? FieldTypes.shortInputField : FieldTypes.primaryInputField}/>
    </div>
  )

  // Handle click outside responsive filter/search list
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        filterSearchListRef.current && 
        !filterSearchListRef.current.contains(event.target as Node)
      ) {
        setShowfilterSearchList(false);
      }
    };

    if (showfilterSearchList) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showfilterSearchList]);
  // #endregion

  // TODO: Translate all above
  return (
    <frames.Page_inner>
      <frames._page_inner_header>
        <div style={{display: "flex", flexDirection: "row", alignItems: "start", justifyContent: "space-between"}}>
          <PageHeader topHeader={t("reports.report")} subHeader={t("reports.archive")}/>
          <div ref={filterSearchListRef}>
            {!mobileXs ? <>{filterSearchList}</>
            : showfilterSearchList ? <>
              <div onClick={() => setShowfilterSearchList(false)} style={{ cursor: "pointer" }}>
                <glyphs.Close size="25px"/>
              </div> 
              <div style={{ position: "absolute", top: "50px", right: "20px", zIndex: "1000" }}>
                {filterSearchList}
              </div>
            </> : 
              <Button content={""} 
                onClick={() => setShowfilterSearchList(true)}
                buttonType={ButtonTypes.textButton}
                startEnhancer={glyphs.Setting({size: "25px"})}
              /> 
            }
          </div>
        </div>
      </frames._page_inner_header>
      <frames._page_inner_content>
        {/* Wrap of Reports Cards */}
        <div style={{
          height: "100%", 
          width: "100%", 
          overflowY: "scroll",     
          scrollbarColor: colors.greyDarkPrimary + colors.transparent,
          scrollbarWidth: "thin"
        }}>
          <frames.CardsColumnCount>
          {sortedReports.map((report) => (
              <ArchivedReportCard key={report.id} reportId={report.id} onReportSelect={onReportSelect} />
            ))}
          </frames.CardsColumnCount>
        </div>
      </frames._page_inner_content>
    </frames.Page_inner>
  )
}

// onChange={(e) => setIsFiltered(e ? e.id : 0)}